import { name } from './constants';
import reducer from './reducer';
import InOut from './InOut';

export default {
  name,
  InOut,
  reducer,
};



// WEBPACK FOOTER //
// ./src/sites/inOut/index.js